import { Avatar } from "@mui/material";
import { Progress } from "antd";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import MessageIcon from "@/Components/Icons/MessageIcon";
import { routingConstants } from "@/Constants/routingConstants";
import { fetchChatMessages, setChatOpen } from "@/reducers/chat";

import { toggleShowUpcomingBookingViewModal } from "../../../../reducers/clientdashboard";

/**
 * Renders a ContractInfoPopup component with the given data.
 *
 * @param {Object} data - the data object containing contract information
 * @return {JSX.Element} the ContractInfoPopup component
 */
const ContractInfoPopup = ({ data }) => {
  const {
    contract_ref_no,
    contract_date_formatted,
    contract_duration,
    candidate_name,
    profile_image,
    role_name,
    licence_no,
    profile_percent,
    contract_start_time,
    contract_end_time,
    mobile_phone_number,
    candidate_email,
    breakTimeSTR,
    route_id,
    route_contract_id,
    candidate_id,
  } = data;
  const dispatch = useDispatch();
  const { clientUserAllPermissions } = useSelector((state) => state.session);

  /**
   * Returns the color code based on the percentage value.
   *
   * @param {number} percentage - The percentage value
   * @return {string} The color code
   */
  const getProgressColor = (percentage) => {
    if (percentage <= 50) {
      return "#ED3A3E";
    } else if (percentage > 51 && percentage < 100) {
      return "#FFC446";
    } else if ((percentage = 100)) {
      return "#5EBB5B";
    }
  };
  /**
   * Generate the name and role of a person with a link and styling.
   *
   * @param {type} _name - the name of the person
   * @param {type} _role - the role of the person
   * @param {type} _route_id - the route id for the link
   * @return {type} the JSX element containing the name, role, and styling
   */
  const getName_Role = (_name, _route_id) => {
    return (
      <div className="flex w-full items-center justify-between">
        {!clientUserAllPermissions ||
        clientUserAllPermissions.is_allow_to_view_candidate_profile === 1 ? (
          _route_id ? (
            <Link
              to={routingConstants.candidateDetail(_route_id)}
              className="truncate text-[14px] font-medium leading-[normal]"
            >
              {_name}
            </Link>
          ) : (
            <span className="cursor-defaullt truncate text-[14px] font-medium leading-[normal]">
              {_name}
            </span>
          )
        ) : (
          <span className="cursor-defaullt truncate text-[14px] font-medium leading-[normal]">
            {_name}
          </span>
        )}
        {/* {_route_id ? (
          <Link
            to={routingConstants.candidateDetail(_route_id)}
            className="truncate text-[14px] font-medium leading-[normal]"
          >
            {_name}
          </Link>
        ) : (
          <span className="cursor-defaullt truncate text-[14px] font-medium leading-[normal]">
            {_name}
          </span>
        )} */}
        {!clientUserAllPermissions ||
        clientUserAllPermissions.is_allow_to_chat === 1 ? (
          <>
            <button
              className="rounded-md px-2 py-1 text-primary"
              onClick={() => {
                dispatch(
                  fetchChatMessages({
                    userType: "Client",
                    id: candidate_id,
                  }),
                );
                dispatch(setChatOpen(true));
                dispatch(toggleShowUpcomingBookingViewModal(false));
              }}
            >
              <MessageIcon cls="w-[20px] h-[20px]" />
            </button>
          </>
        ) : null}
      </div>
    );
  };
  return (
    <div className="grid min-h-[130px] w-[417px] grid-cols-[91px,1fr]">
      <div className="flex h-full min-w-[91px] flex-col items-center gap-[10px] bg-[#E9F1FD] px-1 py-3 text-primary">
        {!clientUserAllPermissions ||
        clientUserAllPermissions.is_allow_to_view_contract_detail === 1 ? (
          <>
            <Link
              to={routingConstants.contractDetail(route_contract_id)}
              className="text-[12px] font-normal text-primary"
            >
              {contract_ref_no}
            </Link>
          </>
        ) : (
          <span className="cursor-default text-[12px] font-normal text-primary">
            {contract_ref_no}
          </span>
        )}

        {/* <Link
          to={routingConstants.contractDetail(route_contract_id)}
          className="text-xs font-medium"
        >
          {contract_ref_no}
        </Link> */}
        <span
          className="text-center text-[16px] font-medium lg:text-[18px]"
          dangerouslySetInnerHTML={{
            __html: contract_date_formatted,
          }}
        ></span>
        <span className="text-[12px] font-medium">
          {contract_duration} {contract_duration > 1 ? "Hours" : "Hour"}
        </span>
      </div>
      <div className="flex h-full max-w-[calc(417px-91px)] grow flex-col gap-[6px] px-3 py-2">
        <div className="flex w-full max-w-full grow gap-3">
          <Avatar
            alt={candidate_name}
            sx={{ width: 45, height: 45 }}
            src={profile_image ? profile_image : ""}
          />
          <div className="max-w-[calc(100%-57px)] grow">
            {getName_Role(candidate_name, route_id)}
            <div>
              <span className="inline-block h-[22px] text-base font-medium text-txtColor">
                {licence_no}
              </span>
            </div>
            <div className="w-[200px]">
              <Progress
                percent={profile_percent}
                size="small"
                strokeColor={getProgressColor(profile_percent)}
                format={(percentage) => {
                  return (
                    <span className="font-openSans text-[12px] font-semibold leading-[normal]">
                      {percentage}%
                    </span>
                  );
                }}
              />
            </div>
          </div>
        </div>
        <div>
          <div className="grid max-w-[300px] grid-cols-2 gap-x-4 gap-y-[6px] text-[12px] font-medium leading-[normal] text-txtDark">
            <span>
              {moment(contract_start_time, "HH:mm:ss").format("HH:mm")} -{" "}
              {moment(contract_end_time, "HH:mm:ss").format("HH:mm")}
            </span>
            <div className="row-span-2 flex items-center justify-end">
              <span className="line-clamp-2 flex min-h-[24px] min-w-[73px] items-center justify-center rounded-[4px] bg-lightblue px-2 py-1 text-[12px] font-bold text-primary">
                {role_name}
              </span>
            </div>
            {/* <span>{mobile_phone_number}</span> */}
            <span>{breakTimeSTR}</span>
            {/* <span className="truncate">{candidate_email}</span> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractInfoPopup;
